import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getMessaging } from 'firebase/messaging';

const googleCloudProjectId = process.env.REACT_APP_GOOGLE_CLOUD_PROJECT_ID;
const firebaseApiKey = process.env.REACT_APP_GOOGLE_CLOUD_FIREBASE_API_KEY;
const firebaseAuthDomain = process.env.REACT_APP_GOOGLE_CLOUD_FIREBASE_AUTH_DOMAIN;
const firebaseStorageBucket = process.env.REACT_APP_GOOGLE_CLOUD_FIREBASE_STORAGE_BUCKET;
const firebaseMessagingSenderId = process.env.REACT_APP_GOOGLE_CLOUD_FIREBASE_MSG_SENDER_ID;
const firebaseAppId = process.env.REACT_APP_GOOGLE_CLOUD_FIREBASE_APP_ID;
const firebaseConfig = {
  apiKey: firebaseApiKey,
  authDomain: firebaseAuthDomain,
  projectId: googleCloudProjectId,
  storageBucket: firebaseStorageBucket,
  messagingSenderId: firebaseMessagingSenderId,
  appId: firebaseAppId,
};
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

let messaging;

if (process.env.REACT_APP_ENV !== 'Development') {
  messaging = getMessaging(app);
};

export { auth, messaging, app };